export const GET_UNREAD_NOTIFICATION_COUNT_SUCCESS = "GET_UNREAD_NOTIFICATION_COUNT_SUCCESS";
export const UPDATE_UNREAD_NOTIFICATION_COUNT_SUCCESS = "UPDATE_UNREAD_NOTIFICATION_COUNT_SUCCESS";
